import React from 'react'

function PlatformIcon() {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 2H5C4.44772 2 4 2.44772 4 3V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V3C20 2.44772 19.5523 2 19 2Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 8H17" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 12H17" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 16H17" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 6V18" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

export default PlatformIcon